import Http from '@/api/http.js'

export default {

  index() {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/contacts`)
  },

  indexByModel({model, id}) {
    return Http.get(`${model}/${id}/contacts`)
  },

  create(contact){
    return Http.post(`/contacts`, {contact: {...contact}})
  },

  update(contact){
    return Http.put(`/contacts/${contact.id}`, {
      contact: {...contact},
    });
  },

  show(id) {
    return Http.get(`/contacts/${id}`);
  },

  delete(id){
    return Http.delete(`/contacts/${id}`)
  }

}
